import React from 'react';
import { useNavigate } from 'react-router-dom';

// ─── Inline Styles for Dark Theme ──────────────────────────────────────────────
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap');

  .admin-wrapper {
    background: #0a0a0a;
    color: #f0f0f0;
    min-height: 100vh;
    padding: 4rem 2rem;
    font-family: 'DM Sans', sans-serif;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .admin-header {
    text-align: center;
    margin-bottom: 3rem;
  }
  .admin-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 3.5rem;
    letter-spacing: 0.06em;
    margin-bottom: 0.5rem;
  }
  .admin-title span {
    color: #e8ff3c; /* Yellow accent */
  }
  .admin-subtitle {
    color: #666;
    font-size: 1rem;
    letter-spacing: 0.05em;
  }
  
  /* Grid Layout for the Cards */
  .dashboard-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    max-width: 800px;
    width: 100%;
  }

  /* Interactive Cards */
  .nav-card {
    background: #111111;
    border: 1px solid #2a2a2a;
    border-radius: 12px;
    padding: 3rem 2rem;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .nav-card:hover {
    border-color: #e8ff3c;
    background: rgba(232, 255, 60, 0.03);
    transform: translateY(-5px);
  }
  
  .nav-icon {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }
  .nav-title {
    font-family: 'Bebas Neue', sans-serif;
    font-size: 2rem;
    letter-spacing: 0.08em;
    margin-bottom: 0.5rem;
    color: #f0f0f0;
  }
  .nav-desc {
    color: #888;
    font-size: 0.9rem;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    .dashboard-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const AdminPage = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-wrapper">
      <style>{styles}</style>
      
      <div className="admin-header">
        <h1 className="admin-title">ADMIN <span>DASHBOARD</span></h1>
        <p className="admin-subtitle">Select a module to manage your platform.</p>
      </div>

      <div className="dashboard-grid">
        
        {/* --- Music Manager Card --- */}
        <div 
          className="nav-card"
          onClick={() => navigate('/sms/musicmanager')}
        >
          <div className="nav-icon">🎵</div>
          <h2 className="nav-title">MUSIC MANAGER</h2>
          <p className="nav-desc">
            Upload new beats, set standard and premium pricing, and delete old tracks from your library.
          </p>
        </div>

        {/* --- Category Manager Card --- */}
        <div 
          className="nav-card"
          onClick={() => navigate('/sms/categorymanager')}
        >
          <div className="nav-icon">📁</div>
          <h2 className="nav-title">CATEGORY MANAGER</h2>
          <p className="nav-desc">
            Create and organize genres (Afrobeats, Trap, R&B, etc.) to keep your beat catalog structured.
          </p>
        </div>

      </div>
    </div>
  );
};

export default AdminPage;